var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import LibZL from "@zerolight-core/libzl";
;
;
;
function loadScript(src, integrity, crossorigin = "anonymous") {
    return new Promise((resolve, reject) => {
        const script = document.createElement("script");
        script.crossOrigin = crossorigin;
        if (integrity) {
            script.integrity = integrity;
        }
        script.onload = resolve;
        script.onerror = reject;
        script.src = src;
        document.head.appendChild(script);
    });
}
/**
 * @returns Load LibZL library in runtime
 *
 * @example
 * ```ts
 * getLibZL({version: "4.2.4"});
 * getLibZL({url: "https://libzl.zlthunder.net/v3/version/4.2.4/libzl.js"});
 * getLibZL({label: "pon1/live"});
 * ```
 */
export function getLibZL(props) {
    return __awaiter(this, void 0, void 0, function* () {
        const stub = "https://libzl.zlthunder.net";
        let url = undefined;
        if ("url" in props) {
            url = props.url;
        }
        else if ("version" in props) {
            url = `${stub}/libzl/versions/${props.version}/libzl.js`;
            if (props.version !== "latest") {
                const semver = props.version.split(".");
                if (parseInt(semver[0]) < 5 && parseInt(semver[1]) < 4) { // 4.3.x last of the old location
                    url = `${stub}/v3/version/${props.version}/libzl.js`;
                }
            }
        }
        else if ("label" in props) {
            url = `${stub}/libzl/labels/${props.label}/libzl.js`;
        }
        else {
            return new LibZL(props.origin, props.console);
        }
        yield loadScript(url, props.integrity);
        return (new (window["LibZL"])(props.origin, props.console));
    });
}
